module.exports = __webpack_public_path__ + "img/time_square.2881eb08.svg";